<template>
  <van-col span="24">
    <!-- ✅ Блок загрузки -->
    <div v-if="isLoadingStatus" class="loading-block">
      <van-loading type="spinner" />
      <p class="loading-text">Перевіряємо ваш статус...</p>
    </div>

    <!-- ✅ Основной контент -->
    <div v-else>
      <!-- ШАГ 1: Форма отправки показаний -->
      <table v-if="formStep === 1" class="send-indications-table">
        <template v-for="index in meterageZone">
          <tbody :key="index" class="indications-block">
            <tr class="standart-size">
              <th class="apply-loader">
                {{ $t("regionalEnergy.sendIndications.previousIndications") }}
              </th>
              <th class="apply-loader">
                {{
                  $t(
                    "regionalEnergy.sendIndications.newIndications" +
                      (meterageZone === 2 ? "" : "_") +
                      (index + (meterageZone === 2 ? 1 : 0))
                  )
                }}
              </th>
            </tr>
            <tr class="standart-size">
              <td class="apply-loader">
                <div class="prev-ind-wrapper">
                  {{
                    lastIndicators[
                      `value${index + (meterageZone === 4 ? 2 : 0)}`
                    ]
                  }}
                </div>
              </td>
              <td class="apply-loader">
                <itserve-input
                  type="number"
                  inputmode="numeric"
                  v-model.number="
                    indications[`value${index + (meterageZone === 4 ? 2 : 0)}`]
                  "
                  variant="small"
                  :name="`value${index + (meterageZone === 4 ? 2 : 0)}`"
                  :placeholder="
                    $t('regionalEnergy.sendIndications.putIndications')
                  "
                />
              </td>
            </tr>
          </tbody>
        </template>
      </table>

      <!-- ШАГ 2: Добавление договора -->
      <div v-if="formStep === 2" key="step2" class="credentials-inputs">
        <div class="info-text">
          {{ $t("regionalEnergy.sendIndications.noContractPrompt") }}
        </div>
        <input
          v-model="indications.contract_number"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.contractNumberPlaceholder')
          "
        />
        <input
          v-model="indications.meter_number"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.meterNumberPlaceholder')
          "
        />
        <template v-for="index in meterageZone">
          <input
            :key="index"
            v-model.number="
              indications[`value${index + (meterageZone === 4 ? 2 : 0)}`]
            "
            type="number"
            class="apply-loader dark-theme-input"
            :placeholder="
              $t(
                'regionalEnergy.sendIndications.newIndications' +
                  (meterageZone === 2 ? '' : '_') +
                  (index + (meterageZone === 2 ? 1 : 0))
              )
            "
          />
        </template>
      </div>

      <!-- ШАГ 3: Форма регистрации -->
      <div v-if="formStep === 3" key="step3" class="credentials-inputs">
        <div class="info-text">
          {{ $t("regionalEnergy.sendIndications.loginErrorPrompt") }}
        </div>
        <input
          v-model="indications.first_name"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.firstNamePlaceholder')
          "
        />
        <input
          v-model="indications.last_name"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.lastNamePlaceholder')
          "
        />
        <input
          v-model="indications.password"
          type="password"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.newPasswordPlaceholder')
          "
        />
        <input
          v-model="indications.confirm_password"
          type="password"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.confirmPasswordPlaceholder')
          "
        />
      </div>
      <itserve-button
        type="primary"
        :value="buttonText"
        class="itserve-button-wide mt-15 apply-loader"
        @click="sendIndications"
      ></itserve-button>
      <simple-dialog
        v-model="showDialog"
        :title="dialogMessage"
        :success="dialogSuccessMessage"
        @change="goToHomePage"
      />
    </div>
  </van-col>
</template>

<script>
import indications from "@/mixins/regional-energy/indications";
import SimpleDialog from "@/components/content/SimpleDialog";
import { Loading } from "vant";

export default {
  components: { SimpleDialog, VanLoading: Loading },
  mixins: [indications],
  name: "MultiZoneStandart",
  props: {
    initialFormStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      formStep: this.initialFormStep,
      isLoadingStatus: false,
    };
  },
  computed: {
    buttonText() {
      if (this.formStep === 1)
        return this.$t("regionalEnergy.sendIndications.buttonSend");
      if (this.formStep === 2) return this.$t("buttons.addAccount");
      if (this.formStep === 3)
        return this.$t("regionalEnergy.sendIndications.buttonRegister");
      return this.$t("regionalEnergy.sendIndications.buttonSend");
    },
  },
  watch: {
    initialFormStep(newValue) {
      this.formStep = newValue;
    },
  },
};
</script>

<style scoped>
/* Стили для блока загрузки */
.loading-block {
  margin-top: 20vh;
  text-align: center;
}
.loading-text {
  color: #bdc3c7;
  margin-top: 15px;
  font-size: 16px;
}

.info-text {
  padding: 10px 15px;
  background-color: #2c3e50;
  color: #ecf0f1;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 0;
  text-align: center;
  font-size: 14px;
}
.credentials-inputs {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dark-theme-input {
  background-color: #2c3e50;
  color: #ecf0f1;
  border: 1px solid #34495e;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

.dark-theme-input::placeholder {
  color: #95a5a6;
}

.prev-ind-wrapper {
  margin-top: 17px;
}
.send-indications-table {
  margin-top: 10px;
}
table {
  width: 100%;
}
.info-table th {
  text-align: left;
  padding-left: 24px;
  padding-top: 12px;
  font-size: 16px;
  color: #0b0b0b;
  font-weight: normal;
}
.info-table td {
  font-size: 16px;
  padding-right: 24px;
  text-align: right;
  color: #918dab;
}
.send-indications-table th {
  font-size: 16px;
  color: #2e73b4;
  padding-top: 3px;
  text-align: center;
}
.send-indications-table td {
  color: #0b0b0b;
  font-size: 16px;
  padding-top: 7px;
  width: 50%;
}
.indications-block tr th {
  padding-top: 10px;
}
</style>
